import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lb-full-width-separator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lb-full-width-separator.component.html',
  styleUrls: ['./lb-full-width-separator.component.scss']
})
export class LbFullWidthSeparatorComponent {
  @Input() title: string = 'Default Title';
}
